module.exports = __webpack_public_path__ + "img/ado_e_ang.c1ab38bc.jpg";